import { z } from "zod";

const taskDataSchema = z.object({
	title: z.string(),
});

export type TaskData = z.infer<typeof taskDataSchema>;

export const parseTaskData = (data: unknown): TaskData | null => {
	const result = taskDataSchema.safeParse(data);
	return result.success ? result.data : null;
};
